import React from 'react';

interface SwitchProps {
  isOn: boolean;
  onChange?: (isOn: boolean) => void;
}

const Switch: React.FC<SwitchProps> = ({ isOn, onChange }) => {
  const trackColor = isOn ? '--bcs-semantic-switch-bg-on' : '--bcs-semantic-switch-bg-off';
  const thumbOffset = !isOn ? 'start-[6px]' : 'start-[30px]';
  const thumbSize = isOn ? 'w-[20px] h-[20px]' : 'w-[12px] h-[12px]';
  const onClick = onChange ? () => onChange(!isOn) : () => {};

  return (
    <div className={`relative flex h-[28px] w-[54px] flex-row items-center rounded-full transition-all`} style={{ background: `var(${trackColor})` }} onClick={onClick}>
      <div className={`${thumbOffset} ${thumbSize} absolute rounded-full bg-white transition-all`} />
    </div>
  );
};

export default Switch;
